// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2Bn9d","content":"LoadingAlert_content__3pNOC"};